<script lang="ts">
	import { useReleaseContext } from '../../context/release';
	import { Loader2, PartyPopper, Download, CheckCircle } from 'lucide-svelte';

	// Phase 3: Use cleaner context interface
	const { releaseConfigState, releaseRuntimeState } = useReleaseContext();

	let isApple = $derived(($releaseConfigState.outputFormat ?? 'ddex-ern') === 'apple-itunes');
	let formatLabel = $derived(isApple ? 'Apple iTunes package' : 'DDEX ERN package');

	function createDownloadUrl(): string {
		const xml = $releaseRuntimeState.generatedXML;
		if (!xml) return '';
		const blob = new Blob([xml], { type: 'application/xml' });
		return URL.createObjectURL(blob);
	}

	function getDownloadFilename(): string {
		if (isApple) {
			return 'metadata.xml';
		}
		const releaseIdValue = $releaseConfigState.releaseType === 'SingleResourceRelease'
			? $releaseConfigState.releaseId?.proprietaryId?.value
			: $releaseConfigState.releaseId?.ICPN;
		return releaseIdValue ? `${releaseIdValue}.xml` : 'release.xml';
	}
</script>

{#if !$releaseRuntimeState.deliveryPath}
	<!-- Loading State -->
	<div class="space-y-8">

		<div class="card card-hover animate-slide-up">
			<div class="card-body text-center">
				<div class="avatar avatar-lg bg-blue-600 text-white mx-auto mb-6 animate-pulse">
					<Loader2 size={32} class="animate-spin" />
				</div>
				<h2 class="text-3xl font-bold text-gray-900 mb-3">Delivering Release</h2>
				<p class="text-lg text-gray-600">Sending your release to the platform...</p>
			</div>
		</div>
	</div>
{:else}
	<!-- Complete State -->
	<div class="space-y-8">

		<!-- Success Alert -->
		<div class="alert alert-success animate-slide-up">
			<div class="flex items-start gap-4">
				<div class="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center flex-shrink-0">
					<PartyPopper size={24} />
				</div>
				<div class="flex-1">
					<h3 class="text-xl font-bold text-green-900 mb-1">Release Delivered Successfully!</h3>
					<p class="text-green-700">Your {formatLabel} has been processed and delivered</p>
				</div>
			</div>
		</div>

		<!-- Download Section -->
		<div class="card card-hover animate-scale-in">
			<div class="card-body text-center">
				<div class="avatar avatar-lg bg-gradient-to-r from-green-600 to-blue-600 text-white mx-auto mb-6">
					<Download size={32} />
				</div>
				<h2 class="text-3xl font-bold text-gray-900 mb-3">Download Your Release</h2>
				<p class="text-lg text-gray-600 mb-8">Your XML file is ready for download</p>
				<a
					class="btn btn-primary btn-lg"
					href={createDownloadUrl()}
					download={getDownloadFilename()}
				>
					<Download size={20} />
					Download XML File
				</a>
			</div>
		</div>
	</div>
{/if}